<template>
  <div class="house">
    <div class="house-list">

      <mt-cell-swipe   v-for="(list, index) in communityInfo" :key="index"  :right="[{content: '常住房间', style: { background: '#ffae14', color: '#fff' }, handler: () => default_room(list.id,list.room_id,list.village_token)}, {content: '删除', style: { background: '#ff3b2f', color: '#fff', lineHeight: '84px;' }, handler: () => unAssign(list.id,index,list.room_id)}]">
        <div class="house-item" slot="title">
          <div class="house-info" @click="jumpPage(list.room_id,list.village_token)">
            <p>{{list.village_name}}<i v-if="room_id == list.room_id"></i></p>
            <p>{{list.position_info}}</p>
          </div>
          <div class="house-identity">
            <!-- <span v-if="list.status" class="assign-btn" @click="toAssign(list.room_id,list.id)">业主认证</span>
            <span v-else class="assigned-btn">已认证</span> -->
            <span class="assign-btn-del" @click="unAssign(list.id,index)">解绑</span>
            <span class="assign-btn" @click="jumpPage(list.room_id,list.village_token)">去缴费</span>
            <!-- <span class="unassign-btn" @click="unAssign(list.id,index)">解除绑定</span> -->
          </div>
        </div>
      </mt-cell-swipe>

      <p class="none-data" v-if="communityInfo.length === 0">点击“添加我的房屋”按钮选择你所在的楼栋、单元、房间，添加完成后即可享受服务。</p>

    </div>

    <div class="add-house">
      <button @click="addMyHouse()">添加我的房屋</button>
    </div>
  </div>
</template>

<script>
import {MessageBox} from 'mint-ui';
export default {
  name: 'MyHouse',
  data () {
    return {
      assign: true, // 去认证
      communityInfo: [],
      v_token:'',     //注意: 是常住房间所在小区token, 非url传来的小区级别token, 注意区分
      userId:'',
      checked: -1 ,// 常住房间选中(不用了,改为用room_id判断常住房间)
      property_token:'',   //级别标识
      city_id: 0,    //级别标识
      room_id:0
    }
  },
  created(){
      this.userId = this.$route.query.userId;
      // this.v_token = this.$route.query.token;
      this.property_token = this.$route.query.property_token;
      this.city_id = this.$route.query.city_id;
      this.getBindRoom(this.userId);
      // this.getData();    
  },
  methods: {
    getBindRoom(userId){
        this.$indicator.open();
        let data = JSON.stringify({'user_id':userId});
        this.axios.get('/jmobile/PropertyFee/now_room/json/'+data).then((res)=>{
            this.$indicator.close();
            if(res.data.status == '1'){
               this.v_token = res.data.data.token;
               this.room_id = res.data.data.room_id;
            }else{
                // MessageBox.alert('请选择常住房间否则无法缴纳物业费','提示');
                // this.$toast({
                //   message:res.data.info,
                //   position:'bottom',
                //   duration:'2000'
                // });
            }
            this.getData();
        }).catch((response)=>{
            this.$toast({
              message:'网络错误',
              position:'bottom',
              duration:'2000'
            });
        });
    },
    // 长住房间
    default_room (link_relate_id,room_id,v_token,is_silent){
      let json = {'user_id':this.userId,'user_uid':this.userId,'link_relate_id':link_relate_id};
          json = JSON.stringify(json);
      this.axios.get('/jmobile/MyVillageRoom/changeDefaultRoom/json/'+json).then((res)=>{
          if(res.data.status == '1'){
              if(is_silent == 'y'){
              }else{
                  this.$toast({
                      message:'长住房间绑定成功',
                      position:'bottom',
                      duration:'2000'
                  });
              }
              this.room_id = room_id;
              this.v_token = v_token;
          }else{
              this.$toast({
                 message:res.data.info,
                 position:'bottom',
                 duration:'2000'
              })
          }
      }).catch((res)=>{
            this.$toast({
               message:'网络错误',
               position:'bottom',
               duration:'2000'
            })
      });
    },
    // swipe - 删除
    remove () {

    },
    // 业主认证
    toAssign (room_id,id) {
      this.$router.push({name: 'MyIdentity', query: {room_id:room_id,'userId':this.userId,link_relate_id:id}}); 
    },
    // 解除绑定
    unAssign(link_relate_id,index,room_id){
        MessageBox({
            title:'提示',
            message:'确定解绑房间？',
            showCancelButton:true
        }).then(action=>{
           if(action == 'confirm'){
              let json;
                  json = {user_id:this.userId,link_relate_id:link_relate_id};
                  json = JSON.stringify(json);
              this.axios.get('/jmobile/MyVillageRoom/del/json/'+json).then((res)=>{

                  if(res.data.status ==  '1'){
                      this.$toast({
                        message:'解绑成功',
                        position:'bottom',
                        duration:'2000'
                      });
                      this.communityInfo.splice(index,1);
                      if(room_id == this.room_id && this.communityInfo.length != 0){    //删除的是常住房间,把列表中的第一个房间设置为常住,设置常住时不要提示成功
                          this.default_room(this.communityInfo[0]['id'],this.communityInfo[0]['room_id'],this.communityInfo[0]['village_token'],'y');
                      }
                  }else{
                      this.$toast({
                        message:res.data.info,
                        position:'bottom',
                        duration:'2000'
                      });
                  }

              }).catch((res)=>{
                 this.$toast({
                    message:'网络错误',
                    position:'bottom',
                    duration:'2000'
                 })
              });
           }
        });
    },

    // 添加我的房屋 注意: 该方法里的v_token指的是跳转后要显示的小区, token指的是级别,而非常住房间所在小区的token, 所以都不能取this.v_token
    addMyHouse () {
      if(this.$route.query.city_id && this.$route.query.city_id != 'undefined'){    //城市级别
          this.$router.push({name: 'SearchCommunity', query: {token:this.$route.query.token,userId:this.$route.query.userId,property_token:this.$route.query.property_token,city_id:this.$route.query.city_id}});
      }
      else if(this.$route.query.property_token && this.$route.query.property_token != 'undefined'){     //物业级别
          let json={property_token:this.$route.query.property_token};
              json=JSON.stringify(json);

          this.axios.get('/jmobile/MyVillageRoom/getVillageByProperty/json/'+json).then((res)=>{
               if(res.data.status == '1'){
                     this.$router.push({name: 'SelectCommunity', query: {v_token:res.data.data[0].v_token,token:this.$route.query.token,userId:this.$route.query.userId,property_token:this.$route.query.property_token,city_id:this.$route.query.city_id}})
               }else{
                  this.$toast({
                      message:res.data.info,
                      position:'bottom',
                      duration:'2000'
                  });
               }
          }).catch((res)=>{
              this.$toast({
                  message:'参数错误',
                  position:'bottom',
                  duration:'2000'
              })
          })
      }else{     //小区级别
          this.$router.push({name: 'SelectCommunity', query: {v_token:this.$route.query.token,token:this.$route.query.token,userId:this.$route.query.userId,property_token:this.$route.query.property_token,city_id:this.$route.query.city_id}});
      }
      
    },
    getData(){
      let json = JSON.stringify({'user_id':this.userId,'user_uid':this.userId,'is_share':true});
      this.$indicator.open();

      this.axios.get('/jmobile/MyVillageRoom/lists/json/'+json).then((res)=>{
           
            if(res.data.status == '1'){
                 if(!this.room_id){
                      MessageBox.alert('请选择常住房间否则无法缴纳物业费','提示');
                 }
                 res.data.data.forEach((item,index)=>{
                      item.status = item.status == '1' ? false : true;
                      this.communityInfo.push(item);
                      // if(item.room_id == this.room_id){
                      //    this.checked = index;
                      // }
                 });
            }else{
              // this.$toast({
              //    message:'为了验证身份在享受物业服务前需要先关联与你相关的房间，点击“添加我的房屋”按钮选择你所在的楼栋、单元、房间，添加完成后即可享受服务',
              //    position:'bottom',
              //    duration:'3000'
              // });
            }
            this.$indicator.close();
      }).catch((response)=>{
        //返回结果
        this.$toast({
          message:'网络错误',
          position:'bottom',
          duration:'3000'
        });
      });
    }, 

    //点击房间的跳转
    jumpPage(room_id,token){
        if(this.$route.query.jump_page && this.$route.query.jump_page == 'Payment'){
          //从缴费页面判断出没有常住房间跳过来的
            this.$router.push({name: 'Payment', query: {token:this.$route.query.token,userId:this.$route.query.userId,property_token:this.$route.query.property_token,city_id:this.$route.query.city_id,room_id:room_id,fee_token:token}});
        }else{
            //默认跳缴费页面
            this.$router.push({name: 'Payment', query: {token:this.$route.query.token,userId:this.$route.query.userId,property_token:this.$route.query.property_token,city_id:this.$route.query.city_id,room_id:room_id,fee_token:token}});
        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.house{
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  .house-list{
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 60px;
    padding-bottom: 5px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    .none-data{
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      width: 85%;
      line-height: 26px;
      text-align: center;
    }
    .house-item{
      display: flex;
      box-sizing: border-box;
      padding: 0 7px 0 14px;
      width: 100%;   
      border-bottom: 1px solid #ececec;
      background-color: #fff;
      height: 84px;
      min-height: 84px;
      max-height: 84px;
      .house-info{
        flex: 1;
        padding: 17px 10px 20px 0;
        p{
          &:first-child{
            margin-bottom: 15px;
            i{
              margin-left: 5px;
              display: inline-block;
              width: 15px;
              height: 15px;
              background-size: 15px 15px;
              background-repeat: no-repeat;
              background-image: url(../assets/selected@2x.png);
              vertical-align: middle;
            }
          }
          &:last-child{
            font-size: 15px;
            color: #717171;
          }
        }
      }
      .house-identity{
        min-width: 80px;
        max-width: 200px;
        align-self: center;
        span{
          display: inline-block;
          width: 60px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          color: #fff;
          font-size: 14px;
          border-radius: 15px;
          &.assign-btn{
            background-color: #ffaf14;
          }
          &.assign-btn-del{
            background-color: red;
          }
          &.assigned-btn{
            background-color: #ffdfa0;
          }
          &.unassign-btn{
            margin-left: 10px;
            background-color: #f0eeec;
            color: #ffaf14;
          }
        }
      }
      
    }
  }
  .mint-cell-swipe{
    .mint-cell-wrapper{
      background-image: none !important;
    }
  }
  .mint-cell-swipe-button{
    padding: 0 15px;
    line-height: 84px;
  }
  .add-house{
    position: absolute;
    box-sizing: border-box;
    height: 45px;
    bottom: 15px;
    left: 0;
    padding: 0 16px 0 14px;
    width: 100%;
    button{
      width: 100%;
      height: 45px;
      line-height: 45px;
      text-align: center;
      color: #fff;
      background-color: #ffaf14;
      border-radius: 5px;
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyHouse.vue